module.exports = __webpack_public_path__ + "static/017.thumb-a26002ce5cb47b9d1e177d1ce7e22af5.jpg";